import React from 'react'
import clsx from 'clsx'
import { UserTag } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ChipAutocomplete from '@SonarCX/components/atoms/ChipAutocomplete'

import { isUUID } from '@SonarCX/utilities'

type PrimaryAssigneeSectionProps = {
  classes: any
  canEdit?: boolean
  setModifiedTask: React.Dispatch<React.SetStateAction<boolean>>
  sendValues: (val: string, field: string) => void
  fullPage?: boolean
  leadObj: any
  setLeadObj: React.Dispatch<React.SetStateAction<any>>
}

const PrimaryAssigneeSection: React.FC<PrimaryAssigneeSectionProps> = ({
  classes,
  canEdit,
  setModifiedTask,
  sendValues,
  fullPage,
  leadObj,
  setLeadObj
}) => {
  const [value, setValue] = React.useState(null)
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        !fullPage && classes.container
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <UserTag size={theme.size.base} variant='Bulk' color='#B64FCD' /> TASK
        LEAD
      </span>

      <div className={clsx(classes.input, !leadObj && classes.upInput)}>
        <ChipAutocomplete
          placeholder={canEdit ? 'Type and Search...' : 'No assigned lead'}
          value={leadObj?.id ?? value}
          onChange={id => {
            setValue(id)

            if (!id) {
              sendValues(null, 'primary_assignee_id')
              return
            }

            if (isUUID(id)) {
              sendValues(id, 'primary_assignee_id')
            }
          }}
          internal
          single
          includeMe
          disabled={!canEdit}
        />
      </div>
    </div>
  )
}

export default PrimaryAssigneeSection
